import { motion } from "framer-motion";
import cartonKraft from "@/assets/materials/carton-kraft.jpg";
import canneSucre from "@/assets/materials/canne-sucre.jpg";
import bioplastique from "@/assets/materials/bioplastique.jpg";
import papierCellulose from "@/assets/materials/papier-cellulose.jpg";

const materials = [
  {
    name: "Carton Kraft",
    description: "Carton recyclable certifié FSC",
    image: cartonKraft,
  },
  {
    name: "Canne à sucre",
    description: "Bagasse compostable naturelle",
    image: canneSucre,
  },
  {
    name: "Bioplastique PLA",
    description: "Amidon de maïs biodégradable",
    image: bioplastique,
  },
  {
    name: "Papier cellulose",
    description: "Fibres végétales renouvelables",
    image: papierCellulose,
  },
];

const MaterialsSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4">
            NOS MATÉRIAUX
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Des matières premières écologiques et durables pour des emballages responsables
          </p>
        </motion.div>

        {/* Materials Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {materials.map((material, index) => (
            <motion.div
              key={material.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group text-center"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden rounded-xl shadow-soft mb-5 aspect-[4/5] bg-muted">
                <img
                  src={material.image}
                  alt={material.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Text */}
              <h3 className="font-display text-xl font-semibold text-foreground mb-2">
                {material.name}
              </h3>
              <p className="text-sm text-muted-foreground">
                {material.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Eco Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-eco/10 rounded-full border border-eco/20">
            <span className="w-3 h-3 bg-eco rounded-full animate-pulse" />
            <span className="text-eco font-medium text-sm">
              Tous nos matériaux sont certifiés écologiques et conformes aux normes européennes
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MaterialsSection;
